module.exports = __webpack_public_path__ + "static/media/screenshot-bug.68eb6722.png";